import API from '@/api';
const Examination = API.get('Examination');

export default ({
  namespaced: true,
  
  state: {
    
    constitutional:             { index_name: 'constitutional',             name: 'Constitutional',             items: [], active: false, note: '' },
    head:                       { index_name: 'head',                       name: 'Head',                       items: [], active: false, note: '' },
    eyes:                       { index_name: 'eyes',                       name: 'Eyes',                       items: [], active: false, note: '' },
    ears_nose_mouth_throat:     { index_name: 'ears_nose_mouth_throat',     name: 'Nose, Mouth, Throat',        items: [], active: false, note: '' },
    cardiovascular:             { index_name: 'cardiovascular',             name: 'Cardiovascular',             items: [], active: false, note: '' },
    respiratory:                { index_name: 'respiratory',                name: 'Respiratory',                items: [], active: false, note: '' },
    gastrointestinal:           { index_name: 'gastrointestinal',           name: 'Gastrointestinal',           items: [], active: false, note: '' },
    genitourinary:              { index_name: 'genitourinary',              name: 'Genito-urinary',             items: [], active: false, note: '' },
    integumentary:              { index_name: 'integumentary',              name: 'Integumentary',              items: [], active: false, note: '' },
    musculoskeletal:            { index_name: 'musculoskeletal',            name: 'Musculoskeletal',            items: [], active: false, note: '' },
    neurologic:                 { index_name: 'neurologic',                 name: 'Neurologic',                 items: [], active: false, note: '' },
    psychiatric:                { index_name: 'psychiatric',                name: 'Psychiatric Symptoms',       items: [], active: false, note: '' },
    hema_lymph_immunologic:     { index_name: 'hema_lymph_immunologic',     name: 'Hema/ Lymph/ Immunologic',   items: [], active: false, note: '' },
    
    examinations: [],
    load_items: [],

    constitutional_items: [],
    head_items: [],
    eyes_items: [],
    ears_nose_mouth_throat_items: [],
    cardiovascular_items: [],
    respiratory_items: [],
    gastrointestinal_items: [],
    genitourinary_items: [],
    integumentary_items: [],
    musculoskeletal_items: [],
    neurologic_items: [],
    psychiatric_items: [],
    hema_lymph_immunologic_items: [],
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  getters: {
    
    /* ############################# ACTIVE ITEMS ############################# */
    
    constitutional: state => state.constitutional.active,
    head: state => state.head.active,
    eyes: state => state.eyes.active,
    ears_nose_mouth_throat: state => state.ears_nose_mouth_throat.active,
    cardiovascular: state => state.cardiovascular.active,
    respiratory: state => state.respiratory.active,
    gastrointestinal: state => state.gastrointestinal.active,
    genitourinary: state => state.genitourinary.active,
    integumentary: state => state.integumentary.active,
    musculoskeletal: state => state.musculoskeletal.active,
    neurologic: state => state.neurologic.active,
    psychiatric: state => state.psychiatric.active,
    hema_lymph_immunologic: state => state.hema_lymph_immunologic.active,

    /* ############################# ACTIVE ITEMS ############################# */



    
    /* ############################# REMARK ############################# */
    
    constitutional_note: state => state.constitutional.note,
    head_note: state => state.head.note,
    eyes_note: state => state.eyes.note,
    ears_nose_mouth_throat_note: state => state.ears_nose_mouth_throat.note,
    cardiovascular_note: state => state.cardiovascular.note,
    respiratory_note: state => state.respiratory.note,
    gastrointestinal_note: state => state.gastrointestinal.note,
    genitourinary_note: state => state.genitourinary.note,
    integumentary_note: state => state.integumentary.note,
    musculoskeletal_note: state => state.musculoskeletal.note,
    neurologic_note: state => state.neurologic.note,
    psychiatric_note: state => state.psychiatric.note,
    hema_lymph_immunologic_note: state => state.hema_lymph_immunologic.note,

    /* ############################# REMARK ############################# */
    
    


    /* ############################# ITEMS ############################# */
    
    constitutional_items: state => state.constitutional_items,
    head_items: state => state.head_items,
    eyes_items: state => state.eyes_items,
    ears_nose_mouth_throat_items: state => state.ears_nose_mouth_throat_items,
    cardiovascular_items: state => state.cardiovascular_items,
    respiratory_items: state => state.respiratory_items,
    gastrointestinal_items: state => state.gastrointestinal_items,
    genitourinary_items: state => state.genitourinary_items,
    integumentary_items: state => state.integumentary_items,
    musculoskeletal_items: state => state.musculoskeletal_items,
    neurologic_items: state => state.neurologic_items,
    psychiatric_items: state => state.psychiatric_items,
    hema_lymph_immunologic_items: state => state.hema_lymph_immunologic_items,

    /* ############################# ITEMS ############################# */

    examinations: state => state.examinations,
    load_items: state => state.load_items,
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {
    updateItems(state, {code, item, value}) {
      var sub_item = state[code+"_items"];
      var index = sub_item.findIndex(e => e == item);

      console.log(index);
      console.log(sub_item);
      console.log(code);
      console.log(item);
      console.log(value);
    },

    /* ############################# SEPARATOR ############################# */

    resetItems(state, code) {
      console.log(code);
      console.log(state[code+"_items_orig_data"]);
      
      // make sure to pass by value
      state[code+"_items"] = JSON.parse(JSON.stringify(state[code+"_items_orig_data"]));
    },

    /* ############################# SEPARATOR ############################# */

    reset_items(state, {code, active}) {
      state[code].active = active;
    },

    /* ############################# SEPARATOR ############################# */

    updateActive(state, {code, active}) {
      state[code].active = active;
    },

    /* ############################# SEPARATOR ############################# */

    updateNote(state, {code, note}) {
      state[code].note = note;
    },

    /* ############################# SEPARATOR ############################# */

    loadSavedData(state, examinations) {

      /* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ EXAMINATION SUB ITEM @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */
     
      state['constitutional_items'] = [
        { name: 'Easy fatigability', active: undefined, value: '' },
        { name: 'Fever', active: undefined, value: '' },
        { name: 'Loss of appetite', active: undefined, value: '' },
        { name: 'Weight loss', active: undefined, value: '' }
      ],
      state['constitutional_items_orig_data'] = JSON.parse(JSON.stringify(state['constitutional_items']));

      
      state['head_items'] = [
        { name: 'Facial asymmetry', active: undefined, value: '' },
        { name: 'Facial swelling', active: undefined, value: '' },
        { name: 'Headache', active: undefined, value: '' }
      ];
      state['head_items_orig_data'] = JSON.parse(JSON.stringify(state['head_items']));

      
      state['eyes_items'] = [
        { name: 'Blurred vision', active: undefined, value: '' },
        { name: 'Double vision', active: undefined, value: '' },
        { name: 'Dryness', active: undefined, value: '' },
        { name: 'Eye Discharge', active: undefined, value: '' },
        { name: 'Eye Glasses⁄Contacts use', active: undefined, value: '' },
        { name: 'Flashing spots', active: undefined, value: '' },
        { name: 'Loss of vision', active: undefined, value: '' },
        { name: 'Pain', active: undefined, value: '' },
        { name: 'Redness', active: undefined, value: '' }
      ],
      state['eyes_items_orig_data'] = JSON.parse(JSON.stringify(state['eyes_items']));


      state['ears_nose_mouth_throat_items'] = [
        { name: 'Difficulty hearing', active: undefined, value: '' },
        { name: 'Dizziness', active: undefined, value: '' },
        { name: 'Ear discharge', active: undefined, value: '' },
        { name: 'Ear pain', active: undefined, value: '' },
        { name: 'Tinnitus', active: undefined, value: '' },
        { name: 'Bleeding gums', active: undefined, value: '' },
        { name: 'Dry lips⁄Mucosa', active: undefined, value: '' },
        { name: 'Dysphagia', active: undefined, value: '' },
        { name: 'Epistaxis', active: undefined, value: '' },
        { name: 'Halitosis', active: undefined, value: '' },
        { name: 'Hoarseness', active: undefined, value: '' },
        { name: 'Mouth sores', active: undefined, value: '' },
        { name: 'Nasal congestion', active: undefined, value: '' },
        { name: 'Sore throat', active: undefined, value: '' },
        { name: 'Throat itchiness', active: undefined, value: '' },
        { name: 'Toothache ', active: undefined, value: '' }
      ],
      state['ears_nose_mouth_throat_items_orig_data'] = JSON.parse(JSON.stringify(state['ears_nose_mouth_throat_items']));


      state['cardiovascular_items'] = [
        { name: 'Chest pain⁄discomfort', active: undefined, value: '' },
        { name: 'Edema', active: undefined, value: '' },
        { name: 'Palpitation', active: undefined, value: '' },
        { name: 'Syncope', active: undefined, value: '' }
      ],
      state['cardiovascular_items_orig_data'] = JSON.parse(JSON.stringify(state['cardiovascular_items']));


      state['respiratory_items'] = [
        { name: 'Cough', active: undefined, value: '' },
        { name: 'Difficulty of breathing', active: undefined, value: '' },
        { name: 'Hemoptysis', active: undefined, value: '' },
        { name: 'Pain on coughing', active: undefined, value: '' },
        { name: 'Wheezing', active: undefined, value: '' }
      ],
      state['respiratory_items_orig_data'] = JSON.parse(JSON.stringify(state['respiratory_items']));


      state['gastrointestinal_items'] = [
        { name: 'Abdominal pain', active: undefined, value: '' },
        { name: 'Bloatedness', active: undefined, value: '' },
        { name: 'Constipation', active: undefined, value: '' },
        { name: 'Diarrhea', active: undefined, value: '' },
        { name: 'Heartburn', active: undefined, value: '' },
        { name: 'Hematemesis', active: undefined, value: '' },
        { name: 'Hematochezia', active: undefined, value: '' },
        { name: 'Jaundice', active: undefined, value: '' },
        { name: 'Melena', active: undefined, value: '' },
        { name: 'Nausea⁄Vomiting', active: undefined, value: '' }
      ],
      state['gastrointestinal_items_orig_data'] = JSON.parse(JSON.stringify(state['gastrointestinal_items']));


      state['genitourinary_items'] = [
        { name: 'Dysuria', active: undefined, value: '' },
        { name: 'Hematuria', active: undefined, value: '' },
        { name: 'Incontinence', active: undefined, value: '' },
        { name: 'Urgency', active: undefined, value: '' },
        { name: 'Urinary frequency', active: undefined, value: '' },
        { name: 'Vaginal⁄Penile discharge', active: undefined, value: '' }
      ],
      state['genitourinary_items_orig_data'] = JSON.parse(JSON.stringify(state['genitourinary_items']));


      state['integumentary_items'] = [
        { name: 'Change in skin color', active: undefined, value: '' },
        { name: 'Discharge from skin', active: undefined, value: '' },
        { name: 'Hair loss', active: undefined, value: '' },
        { name: 'Lesion', active: undefined, value: '' },
        { name: 'Pruritus', active: undefined, value: '' },
        { name: 'Rash', active: undefined, value: '' }
      ],
      state['integumentary_items_orig_data'] = JSON.parse(JSON.stringify(state['integumentary_items']));


      state['musculoskeletal_items'] = [
        { name: 'Back pain', active: undefined, value: '' },
        { name: 'Joint pain⁄swelling', active: undefined, value: '' },
        { name: 'Joint stiffness', active: undefined, value: '' },
        { name: 'Limitation in movement', active: undefined, value: '' },
        { name: 'Muscle pain', active: undefined, value: '' },
        { name: 'Muscle weakness', active: undefined, value: '' },
        { name: 'Muscular swelling', active: undefined, value: '' }
      ],
      state['musculoskeletal_items_orig_data'] = JSON.parse(JSON.stringify(state['musculoskeletal_items']));


      state['neurologic_items'] = [
        { name: 'Headache', active: undefined, value: '' },
        { name: 'Loss of consciousness', active: undefined, value: '' },
        { name: 'Memory loss', active: undefined, value: '' },
        { name: 'Numbness', active: undefined, value: '' },
        { name: 'Paresthesia', active: undefined, value: '' },
        { name: 'Seizure', active: undefined, value: '' },
        { name: 'Tremors', active: undefined, value: '' },
        { name: 'Weakness', active: undefined, value: '' }
      ],
      state['neurologic_items_orig_data'] = JSON.parse(JSON.stringify(state['neurologic_items']));


      state['psychiatric_items'] = [
        { name: 'Anxiety', active: undefined, value: '' },
        { name: 'Depression', active: undefined, value: '' },
        { name: 'Insomnia', active: undefined, value: '' },
        { name: 'Mood disturbances', active: undefined, value: '' }
      ],
      state['psychiatric_items_orig_data'] = JSON.parse(JSON.stringify(state['psychiatric_items']));


      state['hema_lymph_immunologic_items'] = [
        { name: 'Easy bruising', active: undefined },
        { name: 'Easy bleeding', active: undefined },
        { name: 'Pallor', active: undefined },
        { name: 'Frequent infections', active: undefined },
        { name: 'Hives/Wheals', active: undefined },
      ],
      state['hema_lymph_immunologic_items_orig_data'] = JSON.parse(JSON.stringify(state['hema_lymph_immunologic_items']));


      /* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ EXAMINATION SUB ITEM @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */

      state.examinations = examinations;
      examinations.forEach(exam => {

        console.log("[exam instance]", exam);

        let examination_name_index = exam.name.toLowerCase();

        state[examination_name_index].id = exam.id;
        state[examination_name_index].active = true;
        state[examination_name_index+"_note"] = exam.note;
        state[examination_name_index].note = exam.note;

        console.log("exam subname");
        console.log(exam.sub_name);

        console.log("[type of subname]", typeof exam.sub_name);

        if(exam.sub_name !== null) {
          let sub_name_instances = JSON.parse(exam.sub_name);
          state[examination_name_index+"_items"] = sub_name_instances;

          // for resetting purposes
          if(sub_name_instances.length > 0) {
            // to make sure its not passing by reference but passing by value
            state[examination_name_index+"_items_orig_data"] = JSON.parse(JSON.stringify(sub_name_instances));
          }
        }
      });

      console.log("[state]", state);
    },

    /* ############################# SEPARATOR ############################# */

    clearStoreData(state) {
      var items = ['constitutional', 'head', 'eyes', 'ears_nose_mouth_throat', 'cardiovascular', 'respiratory', 'gastrointestinal', 'genitourinary', 'integumentary', 'musculoskeletal', 'neurologic', 'psychiatric', 'hema_lymph_immunologic'];
      items.forEach(item => {
        state[item].items = [];
        state[item].active = false;
        state[item].note = '';
        state[item].id = '';
      });
    }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    async save({state}, {case_id, user_id}) {
      let items = ['constitutional', 'head', 'eyes', 'ears_nose_mouth_throat', 'cardiovascular', 'respiratory', 'gastrointestinal', 'genitourinary', 'integumentary', 'musculoskeletal', 'neurologic', 'psychiatric', 'hema_lymph_immunologic'];
      items.forEach(async item => {
        let payload = {
          patient_case_id: case_id,
          user_id: user_id
        }

        if (state[item].active) {
          payload['id'] = state[item].id;
          payload['name'] = state[item].name;
          payload['value'] = item;
          payload['sub_name'] = state[item].items;
          payload['note'] = state[item].note;
          let response = await Examination.create(payload);
          console.log("[examination/save]", response);
        }
      });
    },

    /* ############################# SEPARATOR ############################# */

    async compiled_examination({state}, {case_id, user_id}) {
      let items = ['constitutional', 'head', 'eyes', 'ears_nose_mouth_throat', 'cardiovascular', 'respiratory', 'gastrointestinal', 'genitourinary', 'integumentary', 'musculoskeletal', 'neurologic', 'psychiatric', 'hema_lymph_immunologic'];
      let compiled_examination = [];
      items.forEach(item => {
        let payload = {
          patient_case_id: case_id,
          user_id: user_id
        }

        if (state[item].active) {
          payload['id'] = state[item].id;
          payload['name'] = item;
          payload['value'] = state[item].active;
          payload['sub_name'] = state[item+"_items"];
          payload['note'] = state[item].note;

          compiled_examination.push(payload);
        }
      });

      return compiled_examination;
    },

    /* ############################# SEPARATOR ############################# */

    async delete(state, examinations) {
      if (examinations) {
        examinations.forEach(async examination => {
          let response = await Examination.delete(examination.id);
          console.log("[examination/delete]", response);
        });
      }
    },
  }
})